export default "__VITE_ASSET__GvLNLKVV__"